import { PosStorePayload } from "../services/posApi";
import { getLocalStorage, setLocalStorage } from "./localstorage";

export const OFFLINE_POS_QUEUE_KEY = "glossa:offline-pos-queue";
export const OFFLINE_POS_QUEUE_CHANGE = "glossa:offline-pos-queue-change";

export interface QueuedPosSale {
  id: string;
  createdAt: string;
  payload: PosStorePayload;
  retryCount: number;
  lastError?: string;
  amountPaid: number;
  changeDue: number;
}

function dispatchQueueChange(): void {
  window.dispatchEvent(new Event(OFFLINE_POS_QUEUE_CHANGE));
}

export function getOfflinePosQueue(): QueuedPosSale[] {
  const items = getLocalStorage<QueuedPosSale[]>(OFFLINE_POS_QUEUE_KEY);
  return Array.isArray(items) ? items : [];
}

export function getOfflinePosQueueCount(): number {
  return getOfflinePosQueue().length;
}

export function enqueueOfflinePosSale(
  sale: Omit<QueuedPosSale, "retryCount" | "createdAt"> & {
    retryCount?: number;
    createdAt?: string;
  },
): QueuedPosSale {
  const entry: QueuedPosSale = {
    ...sale,
    createdAt: sale.createdAt ?? new Date().toISOString(),
    retryCount: sale.retryCount ?? 0,
  };

  const queue = getOfflinePosQueue();
  queue.push(entry);
  setLocalStorage(OFFLINE_POS_QUEUE_KEY, queue);
  dispatchQueueChange();
  return entry;
}

export function removeOfflinePosSale(id: string): void {
  const queue = getOfflinePosQueue().filter((item) => item.id !== id);
  setLocalStorage(OFFLINE_POS_QUEUE_KEY, queue);
  dispatchQueueChange();
}

export function updateOfflinePosSale(
  id: string,
  patch: Partial<Pick<QueuedPosSale, "retryCount" | "lastError">>,
): void {
  const queue = getOfflinePosQueue().map((item) =>
    item.id === id ? { ...item, ...patch } : item,
  );
  setLocalStorage(OFFLINE_POS_QUEUE_KEY, queue);
  dispatchQueueChange();
}

export function isCashOnlyTender(
  payments: Array<{ type: string }>,
): boolean {
  return (
    payments.length > 0 &&
    payments.every((payment) => payment.type === "cash")
  );
}
